import { List } from 'lodash';
import { NavaidModel } from "./navaid";
import {Sectorization} from "./sectorization";

export class sectorizationGraphData{

  constructor( navaid : NavaidModel, defaultDoc : number, minAltitude : number, maxAltitude : number, indexRange: number){
    this.navaid = navaid;
    this.defaultDOC = defaultDoc;
    this.minAltitude = minAltitude;
    this.maxAltitude = maxAltitude;
    this.indexRange = indexRange;
  }

  public navaid: NavaidModel;
  public defaultDOC: number;
  public minAltitude: number;
  public maxAltitude: number;
  public imageBase64: string;
  public altitudeRanges: number[];
  public indexRange: number;

}

export class sectorizationGraphDataGrit{
  public name: string;
  public sectorizations: Sectorization[] = [];

  public defaultDOC: number;
  public minAltitude: number;
  public maxAltitude: number;
  public imageBase64: string;
  public altitudeRanges: number[];
  public indexRange: number;
}
